<template>
  <div class="mx-5">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          class="email-text-area pt-1"
          hide-details
          single-line
          outlined
          label="Role name"
          dense
          :disabled="Readonly"
          v-model="AdminRoleDataTableOne.Name"
          @input="SetName"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="8">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="5"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="itemsPerPage"
              label="Items per page"
              type="number"
              min="-1"
              max="15"
              @input="itemsPerPage = parseInt($event, 10)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
      <div class="d-flex align-center">
        <span class="index_h4">Permissions:</span>
        <div
          class="mx-5 d-flex align-center"
          v-if="Type == 'Edit' || Type == 'Add'"
        >
          <span class="index_h5">Selet all:</span>
          <v-switch
            v-model="multipleRollSelect"
            @change="SelectAll"
            class="mx-4"
          ></v-switch>
        </div>
      </div>
      <v-row no-gutters>
        <v-col cols="12" md="3" sm="6" class="pa-0 ma-0"
          ><div
            class="d-flex align-center"
            v-if="Type == 'Edit' || Type == 'Add'"
          >
            <span class="index_h5">View All:</span>
            <v-switch
              v-model="multipleRollSelectView"
              @change="SelectAllView"
              class="mx-4"
            ></v-switch></div
        ></v-col>
        <v-col cols="12" md="3" sm="6" class="pa-0 ma-0"
          ><div
            class="d-flex align-center"
            v-if="Type == 'Edit' || Type == 'Add'"
          >
            <span class="index_h5">Create All:</span>
            <v-switch
              v-model="multipleRollSelectCreate"
              @change="SelectAllCreate"
              :disabled="!multipleRollSelectView"
              class="mx-4"
            ></v-switch></div
        ></v-col>
        <v-col cols="12" md="3" sm="6" class="pa-0 ma-0"
          ><div
            class="d-flex align-center"
            v-if="Type == 'Edit' || Type == 'Add'"
          >
            <span class="index_h5">Edit All:</span>
            <v-switch
              v-model="multipleRollSelectEdit"
              @change="SelectAllEdit"
              :disabled="!multipleRollSelectView"
              class="mx-4"
            ></v-switch></div
        ></v-col>
        <v-col cols="12" md="3" sm="6" class="pa-0 ma-0"
          ><div
            class="d-flex align-center"
            v-if="Type == 'Edit' || Type == 'Add'"
          >
            <span class="index_h5">Delete All:</span>
            <v-switch
              v-model="multipleRollSelectDelete"
              :disabled="!multipleRollSelectView"
              @change="SelectAllDelete"
              class="mx-4"
            ></v-switch></div
        ></v-col>
      </v-row>

      <v-card class="mt-6" outlined>
        <v-data-table
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
          :headers="headers"
          :items="AdminRoleDataTableOne.RolePermissions"
          :loading="tableLoader"
          :custom-sort="customSort"
          :sort-by="sortColumn"
          :sort-desc="sortDesc"
          @update:sort-by="updateSortColumn"
          @update:sort-desc="updateSortDesc"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.ModuleId`]="{ index }">
            <span class="index_h1_text_style">
              <b> {{ index + 1 }} </b>
            </span>
          </template>
          <template v-slot:[`item.Module`]="{ item }">
            <span class="index_span_2_style"> {{ item.Module }} </span>
          </template>
          <template slot="item.View" slot-scope="{ item }">
            <v-switch
              :disabled="Readonly"
              @change="Togglebtn()"
              v-model="item.View"
            ></v-switch>
          </template>
          <template slot="item.Edit" slot-scope="{ item }">
            <v-switch
              :disabled="Readonly || !item.View"
              @change="Togglebtn()"
              v-model="item.Edit"
            ></v-switch>
          </template>
          <template slot="item.Add" slot-scope="{ item }">
            <v-switch
              :disabled="Readonly || !item.View"
              @change="Togglebtn()"
              v-model="item.Add"
            ></v-switch>
          </template>
          <template slot="item.Delete" slot-scope="{ item }">
            <v-switch
              :disabled="Readonly || !item.View"
              @change="Togglebtn()"
              v-model="item.Delete"
            ></v-switch>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminRoleComponent",
  props: ["Item", "SetItem", "Editdialog", "Type"],
  data() {
    return {
      multipleRollSelect: false,
      multipleRollSelectView: false,
      multipleRollSelectCreate: false,
      multipleRollSelectEdit: false,
      multipleRollSelectDelete: false,

      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      add_dialog: false,
      Readswitch: true,
      Updateswitch: true,
      Createswitch: true,
      Deleteswitch: true,
      btnloader: false,
      Readonly: false,

      tableLoader: false, // data-table true or false
      headers: [
        { text: "#", value: "ModuleId" },
        { text: "Role Name", value: "Module" },
        { text: "", value: "actions", sortable: false },
        { text: "View", value: "View" },
        { text: "Create", value: "Add" },
        { text: "Edit", value: "Edit" },
        { text: "Delete", value: "Delete" },
      ],
      sortColumn: "Module",
      sortDesc: false,
      AdminRoleDataTableOne: [
        {
          index: 1,
          role: "Dashboard",
        },
      ],
    };
  },

  mounted() {
    this.Readonly = false;
    if (this.Type == "Edit") {
      this.AdminRoleDataTableOne = Object.assign({}, this.Item);
      var any = this.AdminRoleDataTableOne.RolePermissions.find(
        (x) => x.View == false
      );
      if (any == undefined) {
        this.multipleRollSelect = true;
      } else {
        this.multipleRollSelect = false;
      }
    } else if (this.Type == "Read") {
      this.AdminRoleDataTableOne = Object.assign({}, this.Item);
      this.Readonly = true;
    } else {
      this.AdminRoleDataTableOne = Object.assign({}, this.Item);
    }
    this.$nextTick(() => {
      this.CheckToggle();
    });
  },

  watch: {
    Item() {
      this.Readonly = false;
      if (this.Type == "Edit") {
        this.AdminRoleDataTableOne = Object.assign({}, this.Item);
      } else if (this.Type == "Read") {
        this.AdminRoleDataTableOne = Object.assign({}, this.Item);
        this.Readonly = true;
      } else {
        this.AdminRoleDataTableOne = Object.assign({}, this.Item);
      }
      this.Togglebtn();
    },
  },
  methods: {
    updateSortColumn(column) {
      this.sortColumn = column;
    },
    updateSortDesc(descending) {
      this.sortDesc = descending;
    },
    SetName() {
      this.$emit("SetName", this.AdminRoleDataTableOne.Name);
    },
    CheckToggle() {
      var IsSelectAll = this.AdminRoleDataTableOne.RolePermissions.find(
        (x) => !x.View || !x.Add || !x.Delete || !x.Edit
      );
      if (IsSelectAll == undefined) {
        this.multipleRollSelect = true;
      } else {
        this.multipleRollSelect = false;
      }

      if (!this.multipleRollSelect) {
        var isViewSelect = this.AdminRoleDataTableOne.RolePermissions.find(
          (x) => !x.View
        );
        if (isViewSelect == undefined) {
          this.multipleRollSelectView = true;
          var isCreateSelect = this.AdminRoleDataTableOne.RolePermissions.find(
            (x) => !x.Add
          );
          if (isCreateSelect == undefined) {
            this.multipleRollSelectCreate = true;
          } else {
            this.multipleRollSelectCreate = false;
          }
          var isEditSelect = this.AdminRoleDataTableOne.RolePermissions.find(
            (x) => !x.Edit
          );
          if (isEditSelect == undefined) {
            this.multipleRollSelectEdit = true;
          } else {
            this.multipleRollSelectEdit = false;
          }
          var isDeleteelect = this.AdminRoleDataTableOne.RolePermissions.find(
            (x) => !x.Delete
          );
          if (isDeleteelect == undefined) {
            this.multipleRollSelectDelete = true;
          } else {
            this.multipleRollSelectDelete = false;
          }
        } else {
          this.multipleRollSelectView = false;
          this.multipleRollSelectCreate = false;
          this.multipleRollSelectDelete = false;
          this.multipleRollSelectEdit = false;
        }
      } else {
        //
        this.multipleRollSelectCreate = true;
        this.multipleRollSelectDelete = true;
        this.multipleRollSelectEdit = true;
        this.multipleRollSelectView = true;
      }
    },
    Togglebtn() {
      this.SetItem(this.AdminRoleDataTableOne);
      this.CheckToggle();
    },
    SelectAll() {
      this.AdminRoleDataTableOne.RolePermissions =
        this.AdminRoleDataTableOne.RolePermissions.map((x) => {
          x.View = this.multipleRollSelect;
          x.Edit = this.multipleRollSelect;
          x.Delete = this.multipleRollSelect;
          x.Add = this.multipleRollSelect;
          return x;
        });
      this.Togglebtn();
    },
    SelectAllView() {
      this.AdminRoleDataTableOne.RolePermissions =
        this.AdminRoleDataTableOne.RolePermissions.map((x) => {
          x.View = this.multipleRollSelectView;
          return x;
        });
      this.Togglebtn();
    },
    SelectAllCreate() {
      this.AdminRoleDataTableOne.RolePermissions =
        this.AdminRoleDataTableOne.RolePermissions.map((x) => {
          x.Add = this.multipleRollSelectCreate;
          return x;
        });
      this.Togglebtn();
    },
    SelectAllEdit() {
      this.AdminRoleDataTableOne.RolePermissions =
        this.AdminRoleDataTableOne.RolePermissions.map((x) => {
          x.Edit = this.multipleRollSelectEdit;
          return x;
        });
      this.Togglebtn();
    },
    SelectAllDelete() {
      this.AdminRoleDataTableOne.RolePermissions =
        this.AdminRoleDataTableOne.RolePermissions.map((x) => {
          x.Delete = this.multipleRollSelectDelete;
          return x;
        });
      this.Togglebtn();
    },
  },
};
</script>
<style scoped>
.v-text-field.v-text-field--enclosed {
  margin: 0;
  padding: 0;
  background-color: white;
}
</style>